import axios from "axios";
import { base_url } from "../../utils/baseUrl";

const createCourseRequest = async (requestData) => {
  console.log(requestData, "course request data");
  const response = await axios.post(`${base_url}course-request/`, requestData);
  return response.data;
};

const courseRequestService = {
  createCourseRequest,
};

export default courseRequestService;
